import React, { useEffect, useState } from 'react';
import { Button, Card, Divider, Skeleton, Table, TableProps, Typography } from 'antd';
import { CardHoldersFilters, SearchCardHolderFilters } from '../../card-holders';
import { CardHolderType, ICardHolder } from '../../../interfaces/card-holder';
import useGetAllCardHolders from '../../../hooks/useGetAllCardHolders';
import type { ColumnsType } from 'antd/es/table';
import { FirstStepFormInputs, SecondStepFormInputs } from '../claim-new';



type FirstStepProps = {
  goToNext?: () => void | null;
  setFirstStepData?: (data: FirstStepFormInputs) => void | null;
  firstStepData?: FirstStepFormInputs | null;
  setSecondStepData?: (data: SecondStepFormInputs) => void | null;
};

const FirstStep: React.FC<FirstStepProps>  = ({ goToNext, setFirstStepData, firstStepData, setSecondStepData }) => { 
 
  const [userInfoFilter, setUserInfoFilter] = useState({
    name: '',
    lastName: '',
    identification: 0,
    active: true,
    type: CardHolderType.Person,
    cardholderId: ''
  });

  const { cardHolders, pageInfo, isLoading, execute } = useGetAllCardHolders(
    0,
    100,
    userInfoFilter,
    true
  );

  const handleSearchClick = async (data: SearchCardHolderFilters) => {
    setUserInfoFilter({
      name: data.firstName,
      lastName: data.lastName,
      identification: data.identificationNumber,
      type: data.cardHolderType,
      active: data.active,
      cardholderId: data.cardholderId
    });
  };

  const columns: ColumnsType<ICardHolder> = [
    {
      dataIndex: 'id',
      key: 'id',
      title: 'ID',
    },
    {
      key: 'first_name',
      dataIndex: 'first_name',
      title: 'Nombre',
      render: (_, record) => {
        return record.first_name ?? record.legal_name ?? 'No registra nombre.';
      },
    },
    {
      key: 'last_name',
      dataIndex: 'last_name',
      title: 'Apellido',
      render: (_, record) => {
        return record.last_name;
      },
    },
    {
      key: 'identifications',
      dataIndex: ['identifications'],
      title: 'Identificacion',
      render: (_, record) => {
        return (
          record.identifications?.filter(
            (identification) =>
              identification?.type === 'CUIL' || identification?.type === 'CUIT' || identification?.type === 'DNI'
          )?.[0]?.number ?? 'No registra identificacion.'
        );
      },
    },
  ];

  const rowSelection: TableProps<ICardHolder>['rowSelection'] = {
    type: "radio",
    selectedRowKeys: (firstStepData !== null && firstStepData.cardHolder) ? [firstStepData.cardHolder.id] : [],
    onChange: (selectedRowKeys: React.Key[], selectedRows: ICardHolder[]) => {
      setFirstStepData( {cardHolder: selectedRows[0] });
      console.log('selectedRow: ', selectedRows[0]);
    },
    columnWidth: 60, // Optional, makes the column tighter
    renderCell: (checked, record, index, originNode) => (
      <div style={{ display: 'flex', justifyContent: 'center', padding:'0px' }}>{originNode}</div>
    )
  };

  useEffect(() => {
    if (userInfoFilter?.name !== "" || userInfoFilter?.lastName !== "" || userInfoFilter?.cardholderId !== "") {
      execute();
    }
  }, [userInfoFilter]);

  useEffect(() => {
    if(firstStepData !== null){
      setUserInfoFilter({
        ...userInfoFilter,
        cardholderId: firstStepData?.cardHolder.id
      })
    }
  }, []);

  return (
    <div>
      <Typography.Title level={2}>Selección de Titular</Typography.Title>
      <Card
        variant="borderless"
        style={{
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
          transform: "translateY(-2px)",
          transition: "all 0.3s ease",
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <CardHoldersFilters onSubmit={handleSearchClick} />
      </Card>
      {
        isLoading ? (
          <Skeleton active paragraph={{ rows: 4 }} style={{marginTop:'1em'}} />
        ) : (
          <Table<ICardHolder>
            style={{marginTop:'1em'}}
            rowKey={"id"}
            rowSelection={{ type: 'radio', ...rowSelection }}
            dataSource={cardHolders ?? []}
            scroll={{ x: true }}
            columns={columns}
            loading={isLoading}
            pagination={false}
          />
        )
      }
      <div style={{ textAlign: 'center', width: '100%', marginTop: '15px' }}>
        <Button disabled={firstStepData === null } onClick={goToNext} type="primary">
          Siguiente
        </Button>
      </div>
    </div>
  )
}

export default FirstStep;